import SearchEngineAdapter from 'Services/Adapters/SearchEngine/SearchEngineAdapter';
import OpportunitiesStatus from 'Config/authenticated/OpportunitiesStatus';
export default class OpportunityAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'opportunity';
    }

    constructor(data = []) {
        super(data);
        this.key = OpportunityAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Opportunité'),
            icon: 'obj-slsy-opportunity',
            count: 0,
            items: [],
        };
    }

    formatItem(item) {
        return {
            id: item.object.id,
            name: item.name,
            ident: item.number,
            related: {
                type: item.related.type,
                name: item.related.name,
                last_name: item.related.last_name,
                first_name: item.related.first_name,
            },
            status: {
                color: OpportunitiesStatus[item.status].chipColor,
                label: OpportunitiesStatus[item.status].label,
            },
            amount: window.sellsyapp.config.globalProperties.$filters.numberFormatCurrency(
                item.amount,
            ),
            link: `/prospection/opportunities/${item.object.id}`,
            component: 'search-result-opportunity',
        };
    }
}
